/**
 * **The mark a widget stamps on itself when the arrow keys are its own.**
 *
 * A document-level shortcut that claims a bare arrow has to stand down while focus is on a widget
 * that walks something with the same keys. ARIA roles answer that for a radio group, a menu or a
 * slider; they do not for a widget whose role says nothing about its keyboard — `ReadoutChart`'s
 * plot is a `role="img"` that is also a tab stop, and its `←` and `→` walk the readings. A selector
 * on the role would have claimed every picture on the page, so the widget says it in so many words.
 *
 * Stamped by `shared/ui/chart/ReadoutChart`, honoured by `pages/tasks/lib/useTaskShortcuts`, where
 * a `→` on a low-reading card's plot used to mark the task done as well as step the readout.
 */
export const OWNS_ARROWS_ATTRIBUTE = 'data-owns-arrows';
